export class SignMessRequests {
	Id: number;
	DeviceId: number;
	PriorityId: number;
	PriorityLevel: number;
	StatusId: number;
	RequestType: string;
	Message: string;
	HashedMessage: string;
	Duration: string;
	Beacons: boolean;
	Location: string;
	ControllerUserName: string;
	TimeRequested: string;
	TimeProcessed: string;
	Timestamp: string;
	ignoreBadWords: boolean;
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/domain-models/SignMessRequests.ts